export * from "./calculateEndTimeFromDuration";
export * from "./dateParseISO";
export * from "./formatStartEndHours";
export * from "./formatStartEndSlotHours";
export * from "./getFirstMondayBefore";
export * from "./getTimeDateObjectFromString";
export * from "./getTimeFromSchedule";
export * from "./getWeekDates";
export * from "./getWeekDayName";
export * from "./limitWeekDateStrings";

import { parse } from "date-fns";

/**
 * Parse a API formatted date in the form
 * yyyy-MM-dd
 * @deprecated use `dateParseISO`, the canonical date-only parser
 * @param str
 */
export function parseApiDate(str: string): Date {
  return parseApiDatetime(`${str} 00:00:00`);
}

/**
 * Parse a API formatted datetime in the form
 * yyyy-MM-dd HH:mm:ss
 * @param str
 */
export function parseApiDatetime(str: string): Date {
  return parse(str, "yyyy-MM-dd HH:mm:ss", new Date());
}

export * from "./dateFnsTz";
export * from "./formatApiDatetime";
export * from "./formatLongDate";
export * from "./formatShortDate";
export * from "./formatZonedTime";
export * from "./generateStringTimeItems";
export * from "./isValidTime";
export * from "./timeStringConverters";
export * from "./utcToWallClock";
